<!--<style>
  .datetime-picker-dropdown {
    top: 36px !important;

  }

  .datetime-picker-dropdown .btn {
    padding: 5px 9px !important;
  }
</style> -->
<!--new search bar -->
<div class="row search-bar">
<!--  <div [ngClass]="{'col-md-3': !showFilter, 'col-lg-3 col-md-4 col-sm-4': showFilter}">-->
  <div class="col-md-3">
        <div class="form-group has-feedback input-group">
            <input (keyup.enter)="runSearch()" [(ngModel)]="searchObj.search" type="text"
                   class="form-control has-feedback has-clear" id="search"
                   style="font-family: Helvetica, FontAwesome" placeholder="&#xF002; Search Applications">
            <i *ngIf="searchObj.search !== undefined && searchObj.search !== ''"
               (click)="searchObj.search = ''; runSearch();"
               class="fa fa-times form-control-feedback"
               style="padding-top:10px; z-index:10; pointer-events: auto; cursor:pointer; margin-right: 4px; position: absolute;
    right: 4px;"></i>
        </div>
    </div>
    <div class="col-md-1" style="padding-top:6px; padding-left:0; width:0;">
        <app-help-docs-links recordType="'search'" color="#333333"></app-help-docs-links>
    </div>


 <!--<div class="row search-bar">
    <div ng-class="{'col-md-3': !showFilter, 'col-lg-3 col-md-4 col-sm-4': showFilter}">
    <div class="form-group has-feedback input-group">
      <input ng-enter="applications.search()" ng-model="applications.searchParams.search" type="text"
             class="form-control has-feedback has-clear" id="search"
             style="font-family: Helvetica, FontAwesome"
             placeholder="&#xF002; Search {{ $state.params.model | capitalize }} Applications">
      <i ng-show="applications.searchParams.search !== undefined && applications.searchParams.search !== ''"
         ng-click="applications.searchParams.search = ''; applications.search();"
         class="fa fa-times form-control-feedback"
         style="padding-top:10px; z-index:10; pointer-events: auto; cursor:pointer; position: absolute; right: 67px;"></i>
      <span class="input-group-btn">
            <button type="button" class="btn btn-primary" style="height:34px;" ng-click="applications.search()">
                <i class="fa fa-search"></i>
            </button>
            </span>
    </div>
  </div>
  <div class="col-md-1" style="padding-top:6px; padding-left:0; width:0;">
    <help-docs-link record-type="search" color="#333333"></help-docs-link>
  </div>
</div>-->

<!--<div class="panel-body" style="background:none;">
     <div class="row">
        <div class="col-md-10">
            <h3 style="margin:10px 10px">
                {{ applications.searchParams.status === '' ? 'All' : '' }} {{ $state.params.model | capitalize }} Applications {{ applications.searchParams.status === '' ? '' : 'Ready for Review' }} -->
                <!--<small><select style="margin:10px 10px" name="actionSelect" id="actionSelect"
                               ng-model="actionSelected.value"
                               ng-change="selectionChange()"
                               ng-options="option.value as option.label for option in bulkOptions">
                </select>
                </small>-->
           <!--  </h3>
        </div> -->
        <!--<div class="col-md-2" style="padding-right:0" ng-if="Sites.meta.permissions.write">
            <a ng-href="{{$state.href('root.display', {app: $state.params.app, model: $state.params.model, id: 'new'})}}">
           <! <button class="btn btn-default pull-right">
                Add New {{ $state.params.app | capitalize }} Site
            </button>
            </a>
        </div>-->
   <!-- </div>
  <div class="row">
    <div class="col-md-12" ng-hide="applications.loading">
      <b>Total: </b>{{ applications.items.meta.count }}
      <span ng-show="applications.searchParams.status === 'initial,resubmit'">(<a style="cursor: pointer"
                                                                                  ng-click="toggleAll()">View All</a>)</span>
      <span ng-show="applications.searchParams.status === ''">(<a style="cursor: pointer" ng-click="toggleAll()">View Application Ready for Review</a>)</span>
    </div>
  </div>-->
   <!-- <results-list sref="root.applications.standbygeneratorview({id: item.facility.globalid})" service="applications"
                  display-fields="displayFields" row-buttons="rowButtons">
    </results-list> -->
</div>


<div class="panel-body" style="background:none;">
    <div class="row">
        <div class="col-md-12">
            <h3 style="margin:10px 0px">{{service.meta.verbose_name}} Submissions Ready for Review</h3>

        </div>
    </div>
    <div class="row">
        <div class="col-md-12">

<!--          search="runSearch"-->
            <app-results-list [service]="service" [displayFields]="displayFields" [showLink]="true"
                              [disableSort]="nonfilterableFields" [items]="items" inputType="none"
                              [searchObj]="searchObj" (loadingResults)="loading = $event" [rowButtons]="rowButtons"></app-results-list>
        </div>
    </div>
</div>
